
import { useSupabaseCount, CountResult } from "./useSupabaseCount";

export function useUserCount(): CountResult {
  return useSupabaseCount("profiles", "user-count");
}
